import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from '@mui/material';
import FunctionalDialog from 'components/Modals/FunctionalDialog';
import { UserLoop } from 'types';
import { remixerApi } from 'services/api/remixer';
import { useMessageSnackbar } from 'services/hooks';
import { ExtraFormulaFields } from 'services/store/remixer/types';

type PropTypes = {
  isOpen: boolean;
  onClose: () => void;
  data: UserLoop;
};

const DeleteUserLoopDialog = ({ isOpen, onClose, data }: PropTypes) => {
  const { t } = useTranslation();
  const [remixSong, { isLoading, isError }] = remixerApi.useRemixSongMutation();
  const { displayErrorSnackbar } = useMessageSnackbar();

  const handleDelete = () => {
    remixSong({
      field: ExtraFormulaFields.RemoveUserLoop,
      value: data,
    });
    onClose();
  };

  useEffect(() => {
    if (isError) {
      displayErrorSnackbar(t('remixer:userLoop:selectorDialog:unknownError'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, t]);

  return (
    <FunctionalDialog
      title={t('remixer:userLoop:deleteDialog:title')}
      description={t('remixer:userLoop:deleteDialog:description')}
      state={{
        isOpen,
        isLoading,
        error: undefined,
      }}
      action={{
        onSubmit: handleDelete,
        onClose,
        onExited: onClose,
      }}
      closeText={t('general:action:cancel')}
      submitText={t('remixer:userLoop:deleteDialog:deleteButtonLabel')}
      buttonVariant="contained"
      buttonColor="error"
    />
  );
};

export default DeleteUserLoopDialog;
